module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/th/3-3b4c81a6789babab01571bf78dc370aa.jpg";